import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { DataGridFlexSales, useDataGridFlexSales, useDataGridSync } from '../DataGridFlexSales';

import {
  reportFilterCountryCodeSelector,
  reportExecutePendingInterfacesSalesSelector,
} from '../../state';
import { ExecutionStatusPendingInterfaces } from '../../types';
import handlerFactory, { ExecutionsPendingInterfacesDataGridContext } from './handlerFactory';

const DataGridConfig = () => {
  const { handler } = useDataGridFlexSales<
    ExecutionStatusPendingInterfaces,
    ExecutionsPendingInterfacesDataGridContext
  >();

  const { t } = useTranslation();
  const title = t('pending-interfaces.titles.execute_interfaces');
  const country = useSelector(reportFilterCountryCodeSelector);
  const salesResource = useSelector(reportExecutePendingInterfacesSalesSelector);
  const { data, loading } = salesResource;

  const gridContext = useMemo(
    () => ({
      t,
      country,
    }),
    [t, country]
  );

  useDataGridSync({
    handler,
    data,
    context: gridContext,
    title,
    loading,
  });

  return null;
};

const ExecutePendingInterfacesDataGrid = () => (
  <DataGridFlexSales handlerFactory={handlerFactory}>
    <DataGridConfig />
  </DataGridFlexSales>
);

export default ExecutePendingInterfacesDataGrid;
